const emailDeliveryStatuses = {
  requested: { label: '送信済', color: 'secondary', isFailed: false },
  delivered: { label: '配信成功', color: 'success', isFailed: false },
  deferred: { label: '配信保留', color: 'warning', isFailed: true },
  bounce: { label: '不達', color: 'danger', isFailed: true },
  dropped: { label: '送信中止', color: 'danger', isFailed: true },
  blocked: { label: 'ブロック', color: 'danger', isFailed: true },
  spamreport: { label: '迷惑メール報告', color: 'danger', isFailed: true },
  unsubscribe: { label: '配信停止', color: 'dark', isFailed: true },
};

// NOTE: SendGridのeventはdeferredのように後からdeliveredに変わりうるので、確定した結果を後退させない
const statusPriorities = {
  requested: 0,
  deferred: 1,
  delivered: 2,
  unsubscribe: 3,
  spamreport: 3,
  blocked: 4,
  dropped: 4,
  bounce: 4,
};

const sendgridEventToStatus = {
  delivered: 'delivered',
  deferred: 'deferred',
  bounce: 'bounce',
  dropped: 'dropped',
  blocked: 'blocked',
  spamreport: 'spamreport',
  unsubscribe: 'unsubscribe',
  group_unsubscribe: 'unsubscribe',
};

const shouldOverwriteStatus = (currentStatus, nextStatus) =>
  (statusPriorities[nextStatus] || 0) >= (statusPriorities[currentStatus] || 0);

const isFailedDeliveryStatus = (status) => emailDeliveryStatuses[status]?.isFailed === true;

module.exports = {
  emailDeliveryStatuses,
  sendgridEventToStatus,
  shouldOverwriteStatus,
  isFailedDeliveryStatus,
};
